import React from "react";
import { Layout } from "antd";
import "./LoginLayout.scss";

const LoginLayout = (props) => {
  return <Layout>{props.children}</Layout>;
};

export default LoginLayout;
